import { render, staticRenderFns } from "./BaseWizardHeader.vue?vue&type=template&id=6b72f8bb&scoped=true"
import script from "./BaseWizardHeader.vue?vue&type=script&lang=js"
export * from "./BaseWizardHeader.vue?vue&type=script&lang=js"
import style0 from "./BaseWizardHeader.vue?vue&type=style&index=0&id=6b72f8bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72f8bb",
  null
  
)

export default component.exports